import { useQuery } from 'react-query';
import { NavLink } from 'react-router-dom';
import FaqsContent from '../components/ui/FaqsContent';

import Loader from '../components/ui/Loader';
import Button from '../components/ui/Button';
import { Icon } from '@mui/material';

import './Faqs.scss';
import { getFaqs } from '../api/questionsAPI';

const FaqsPage = () => {
	const {
		isLoading,
		isError,
		error,
		data: faqs
	} = useQuery({
		queryKey: ['faqs'],
		queryFn: getFaqs,
		staleTime: 3000000 //5 minutes to refetch
	});

	if (isLoading) {
		return <Loader centered />;
	}

	const { generalQuestions } = faqs.data.infoObject;

	return (
		<div className='faqs-main-container'>
			<div className='faqs-title-container'>
				<h1 className='faqs-title'>FAQ</h1>
				<NavLink to={`/contact-us`}>
					<Button className='primary-button' endIcon='mail'>
						Contact Us
					</Button>
				</NavLink>
			</div>
			<FaqsContent
				faqTitle={generalQuestions.billingGrid.question}
				faqContent={generalQuestions.billingGrid.answer}
				expanded={true}
			/>
			<FaqsContent
				faqTitle={
					generalQuestions.coverageAnalysis.question
				}
				faqContent={
					generalQuestions.coverageAnalysis.answer
				}
			/>
			<FaqsContent
				faqTitle={generalQuestions.amendment.question}
				faqContent={generalQuestions.amendment.answer}
			/>
			<FaqsContent
				faqTitle={generalQuestions.ginseng.question}
				faqContent={generalQuestions.ginseng.answer}
			/>
		</div>
	);
};
export default FaqsPage;
